/**
 * Amplitude analytics events
 */
;(function () {
  const body = document.querySelector('body')
  if (!body) return
  const bodyData = body.dataset || {}
  const template = bodyData.template || ''

  // ---------- page_view ----------
  if (window.is_amplitude_enabled && window.amplitude) {
    window.amplitude.track('page_view', {
      page_name: bodyData.pageName || template || 'page',
      signin: bodyData.signin === 'true',
    })
  }

  // ---------- cart_viewed ----------
  if (template === 'cart') {
    if (window.is_amplitude_enabled && window.amplitude) {
      window.amplitude.track('cart_viewed', {
        signin: bodyData.signin === 'true',
        try_on_completed: false,
      })
    }
  }

  // ---------- product_viewed ----------
  if (template === 'product') {
    if (window.is_amplitude_enabled && window.amplitude) {
      const ds = bodyData
      const signinValue = ds.signin === 'true'
      const priceCents = ds.productPrice ? parseInt(ds.productPrice, 10) : null
      const price = priceCents != null ? (priceCents % 1 !== 0 ? priceCents / 100 : priceCents / 100) : null
      const referrer = typeof document.referrer === 'string' ? document.referrer : ''
      let source = 'direct'
      try {
        if (referrer) {
          const refUrl = new URL(referrer)
          if (refUrl.origin === window.location.origin) {
            const path = (refUrl.pathname || '').toLowerCase()
            if (path.indexOf('/search') !== -1) source = 'search'
            else if (path.indexOf('/cart') !== -1) source = 'cart'
            else if (path.indexOf('/collections/') !== -1) source = 'collection'
            else if (path.indexOf('wishlist') !== -1) source = 'wishlist'
            else if (path.indexOf('/account') !== -1) source = 'account'
            else if (path === '/' || path === '') source = 'home'
            else source = 'other'
          } else source = 'external'
        }
      } catch (e) {}
      const props = { signin: signinValue, try_on_completed: false, source }
      if (ds.productId) props.id = ds.productId
      if (ds.productSku) props.sku = ds.productSku
      if (price != null) props.price = price
      if (ds.productCategory) props.product_category = ds.productCategory
      if (ds.productBrand) props.product_brand = ds.productBrand
      window.amplitude.track('product_viewed', props)
    }
  }

  // ---------- email_submitted (newsletter) ----------
  document.querySelectorAll('form[data-ga-name="newsletter_form"]').forEach((form) => {
    form.addEventListener('submit', () => {
      if (window.is_amplitude_enabled && window.amplitude) {
        window.amplitude.track('email_submitted', { description: 'user submitted email' })
      }
    })
  })

  // ---------- login (account page) ----------
  if (template === 'account') {
    const isLoginReferal = sessionStorage.getItem('loginFormSubmitted')
    if (isLoginReferal && window.is_amplitude_enabled && window.amplitude) {
      window.amplitude.track('login', { status: 'login successful' })
    }
  }

  // ---------- added_to_cart (GA_ADD_TO_CART) ----------
  window.addEventListener('GA_ADD_TO_CART', (event) => {
    const item = (event.detail && event.detail.item) || null
    if (!item) return
    const lineItem = item.items && item.items[0] ? item.items[0] : item
    const signinValue = bodyData.signin === 'true'
    const price = lineItem.price != null ? (lineItem.price % 1 !== 0 ? lineItem.price / 100 : lineItem.price) : null
    if (!window.is_amplitude_enabled || !window.amplitude) return
    const props = { signin: signinValue }
    if (lineItem.id != null) props.id = lineItem.id
    if (lineItem.sku != null) props.sku = lineItem.sku
    if (price != null) props.price = price
    if (lineItem.product_type != null) props.product_category = lineItem.product_type
    if (lineItem.vendor != null) props.product_brand = lineItem.vendor
    window.amplitude.track('added_to_cart', props)
  })

  // ---------- checkout_started ----------
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target
      const isCheckoutSubmit =
        form && form.action && form.action.indexOf('cart') !== -1 &&
        (e.submitter && (e.submitter.name === 'checkout' || e.submitter.getAttribute('name') === 'checkout'))
      if (!isCheckoutSubmit) return
      if (!window.is_amplitude_enabled || !window.amplitude) return
      e.preventDefault()
      const checkoutUrl = `${((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '')}/checkout`
      const cartUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? `${window.Shopify.routes.root}cart.js` : '/cart.js'
      fetch(cartUrl)
        .then((r) => { return r.json() })
        .then((cart) => {
          const items = cart.items || []
          const first = items[0]
          const price = first && first.price != null ? (first.price % 1 !== 0 ? first.price / 100 : first.price) : null
          const props = { try_on_completed: false }
          if (first && first.id != null) props.id = first.id
          if (first && first.sku != null) props.sku = first.sku
          if (price != null) props.price = price
          if (first && first.product_type != null) props.product_category = first.product_type
          if (first && first.vendor != null) props.product_brand = first.vendor
          window.amplitude.track('checkout_started', props)
          setTimeout(() => { window.location.href = checkoutUrl }, 150)
        })
        .catch(() => { window.location.href = checkoutUrl })
    },
    true,
  )

  // ---------- search_opened ----------
  function fireAmplitudeSearchOpened (triggerEl) {
    if (!window.is_amplitude_enabled || !window.amplitude) return
    const input = triggerEl.matches && triggerEl.matches('[data-ga-el="searchInput"]')
      ? triggerEl
      : (triggerEl.closest && (triggerEl.closest('form[role="search"]') || triggerEl.closest('.search'))) && (triggerEl.closest('form[role="search"]') || triggerEl.closest('.search')).querySelector('[data-ga-el="searchInput"]')
    const query = (input && input.value) ? input.value.trim() : ''
    let source = 'header'
    if (triggerEl.closest && (triggerEl.closest('.hd-Drawer') || triggerEl.closest('[class*="drawer"]') || triggerEl.closest('[id*="drawer"]'))) {
      source = 'drawer'
    }
    window.amplitude.track('search_opened', {
      signin: bodyData.signin === 'true',
      query,
      source,
    })
  }
  document.querySelectorAll('[data-ga-el="searchIcon"]').forEach((el) => {
    el.addEventListener('click', () => { fireAmplitudeSearchOpened(el) })
  })
  document.querySelectorAll('[data-ga-el="searchInput"]').forEach((inputEl) => {
    inputEl.addEventListener('focus', () => { fireAmplitudeSearchOpened(inputEl) })
  })

  // ---------- size_selected (PDP) ----------
  if (template.indexOf('product') !== -1) {
    const pdpSizeEls = document.querySelectorAll('[data-ga-el="pdpSizeClick"]')
    pdpSizeEls.forEach((input) => {
      input.addEventListener('click', (e) => {
        if (!window.is_amplitude_enabled || !window.amplitude) return
        const el = e.currentTarget
        const ds = el.dataset || {}
        const priceCents = ds.gaVariantPrice ? parseInt(ds.gaVariantPrice, 10) : null
        const price = priceCents != null ? (priceCents % 1 !== 0 ? priceCents / 100 : priceCents / 100) : null
        const props = { try_on_completed: false }
        if (ds.variantId) props.id = ds.variantId
        if (ds.gaVariantSku) props.sku = ds.gaVariantSku
        if (price != null) props.price = price
        if (bodyData.productCategory) props.product_category = bodyData.productCategory
        if (bodyData.productBrand) props.product_brand = bodyData.productBrand
        window.amplitude.track('size_selected', props)
      })
    })
  }
})()
